import React, { Component } from 'react';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactTable from '../common/grid/gridReactTable';
import { getList } from './erroGeralActions';
import { PAGE_SIZE } from '../common/utils/pageSize';
import Button from '../common/form/button';
import TicketSuporteForm from '../ticket_suporte/ticketSuporteForm';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

class ControladorErroGeralList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      pages: null,
      loading: true,
      grupoId: '',
      controladorId: '',
      showTicketModal: false,
      selectedError: null,
    };

    this.fetchData = this.fetchData.bind(this);
    this.handleSetGrupo = this.handleSetGrupo.bind(this);
    this.handleSetControlador = this.handleSetControlador.bind(this);
    this.handleChangeTime = this.handleChangeTime.bind(this);
    this.handleShowTicketModal = this.handleShowTicketModal.bind(this);
    this.handleCloseTicketModal = this.handleCloseTicketModal.bind(this);
  }

  fetchData(state) {
    this.setState({ loading: true });

    this.props.getList(state.page, state.sorted, state.filtered).then(() => {
      this.setState({
        loading: false,
      });
    });
  }

  timeFormat(time) {
    let timeFormatted = time.replace(/\D/g, '');
    let hour = timeFormatted.substring(0, 2);
    let minute = timeFormatted.substring(2, 4);
    let second = timeFormatted.substring(4, 6);
    hour = hour > 23 ? '23' : hour;
    minute = minute > 59 ? '59' : minute;
    second = second > 59 ? '59' : second;
    return `${hour}${minute ? ':' + minute : ''}${second ? ':' + second : ''}`;
  }

  handleChangeTime(value, onChange) {
    const time = this.timeFormat(value);
    onChange(time);
  }

  handleSetGrupo(value) {
    this.setState({ grupoId: value });
  }

  handleSetControlador(value) {
    this.setState({ controladorId: value });
  }

  handleShowTicketModal(error) {
    this.setState({ showTicketModal: true, selectedError: error });
  }

  handleCloseTicketModal() {
    this.setState({ showTicketModal: false, selectedError: null });
  }

  render() {
    moment.locale('pt-br');
    const { data, total, grupos, controladores, ips } = this.props;
    const pages = Math.ceil(total / PAGE_SIZE);
    const columns = [
      {
        Header: 'Data',
        accessor: 'data_erro',
        width: 150,
        filterable: true,
        resizable: true,
        className: 'column_grid column_center',
        Cell: ({ value }) => moment(value).format('DD/MM/YYYY'),
        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => onChange(event.target.value)}
            value={filter ? filter.value : ''}
            type="date"
            className="form-control"
          />
        ),
      },
      {
        Header: 'Hora',
        accessor: 'hora_erro',
        width: 120,
        className: 'column_grid column_center',
        filterable: true,
        resizable: true,
        Filter: ({ filter, onChange }) => (
          <input
            onChange={event => this.handleChangeTime(event.target.value, onChange)}
            value={filter ? filter.value : ''}
            type="text"
            maxLength={8}
            placeholder="hh:mm:ss"
            className="form-control"
          />
        ),
      },
      {
        Header: 'Grupo',
        accessor: 'grupo_fisico_id',
        width: 180,
        filterable: true,
        resizable: true,
        className: 'column_grid column_center',
        Filter: ({ filter, onChange }) => {
          const value = filter ? filter.value : '';
          return (
            <select class={'form-control'} onChange={event => onChange(event.target.value)} value={value}>
              <option value="">Todos</option>
              {grupos &&
                grupos.map(grupo => (
                  <option key={grupo} value={grupo}>
                    {grupo}
                  </option>
                ))}
            </select>
          );
        },
      },
      {
        Header: 'Controlador',
        accessor: 'numero_controlador',
        width: 120,
        filterable: true,
        resizable: true,
        className: 'column_grid column_center',
        Filter: ({ filter, onChange }) => {
          const value = filter ? filter.value : '';
          return (
            <select class={'form-control'} onChange={event => onChange(event.target.value)} value={value}>
              <option value="">Todos</option>
              {controladores &&
                controladores.map(controlador => (
                  <option key={controlador} value={controlador}>
                    {controlador}
                  </option>
                ))}
            </select>
          );
        },
      },
      {
        Header: 'IP/Porta',
        accessor: 'ip_porta',
        width: 150,
        filterable: true,
        resizable: true,
        className: 'column_grid column_center',
        Filter: ({ filter, onChange }) => {
          const value = filter ? filter.value : '';
          return (
            <select class={'form-control'} onChange={event => onChange(event.target.value)} value={value}>
              <option value="">Todos</option>
              {ips &&
                ips.map(ip => (
                  <option key={ip} value={ip}>
                    {ip}
                  </option>
                ))}
            </select>
          );
        },
      },
      {
        Header: 'Mensagem',
        accessor: 'mensagem',
        className: 'column_grid',
        filterable: true,
        resizable: true,
      },
      {
        Header: 'Ações',
        accessor: 'id',
        width: 100,
        className: 'column_grid column_center',
        filterable: false,
        resizable: false,
        Cell: ({ original: error }) => (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-ticket-${error.id_erro}`}>Abrir Ticket</Tooltip>}
          >
            <Button
              className="btn btn-warning btn-sm"
              icon="exclamation-triangle"
              onClick={() => this.handleShowTicketModal(error)}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '1.2em',
                color: '#f39c12',
                padding: '0 5px',
              }}
            />
          </OverlayTrigger>
        ),
      },
    ];

    const { selectedError } = this.state;
    let initialTicketData = null;
    if (selectedError) {
      initialTicketData = {
        titulo: `Erro no Controlador ${selectedError.numero_controlador}`,
        descricao: `Mensagem de Erro: ${selectedError.mensagem}\n\nDetalhes:\n- Data: ${moment(
          selectedError.data_erro,
        ).format('DD/MM/YYYY')}\n- Hora: ${selectedError.hora_erro}\n- Controlador: ${
          selectedError.numero_controlador
        }\n- Grupo Físico: ${selectedError.grupo_fisico_id}\n- IP/Porta: ${selectedError.ip_porta}`,
        grupo_fisico_id: selectedError.grupo_fisico_id,
        numero_controlador: selectedError.numero_controlador,
        controlador_erro_id: selectedError.id_erro,
        isFromError: true,
        controlador_id: '',
      };
    }

    return (
      <div>
        <ReactTable
          manual
          data={data}
          columns={columns}
          pages={pages}
          onFetchData={this.fetchData}
          loading={this.state.loading}
          filterable
          className="-striped -highlight"
          defaultPageSize={PAGE_SIZE}
          showPaginationBottom={true}
        />
        {this.state.showTicketModal && (
          <TicketSuporteForm
            show={this.state.showTicketModal}
            onHide={this.handleCloseTicketModal}
            ticket={initialTicketData}
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({ getList }, dispatch);
export default connect(
  state => ({
    data: state.controladorErroGeralCad.list,
    total: state.controladorErroGeralCad.total,
    grupos: state.controladorErroGeralCad.grupos,
    controladores: state.controladorErroGeralCad.controladores,
    ips: state.controladorErroGeralCad.ips,
  }),
  mapDispatchToProps,
)(ControladorErroGeralList);
